import { createPKCEHelper, PKCEChallenge, PKCEHelperLegacyBrowser } from 'simple-pkce-browser'

export type SSOChallenge = PKCEChallenge

export const { generateChallenge }: PKCEHelperLegacyBrowser = createPKCEHelper()
